import React from "../__compat__/react/main.entry.mjs.mjs";
export function useTransitionEvent(callback) {
    const targetElement = React.useRef(null);
    React.useEffect(() => {
        const currentTargetElement = targetElement.current;
        if (currentTargetElement) {
            currentTargetElement.addEventListener('transitionstart', callback);
            currentTargetElement.addEventListener('transitionend', callback);
        }
        return () => {
            if (currentTargetElement) {
                currentTargetElement.removeEventListener('transitionstart', callback);
                currentTargetElement.removeEventListener('transitionend', callback);
            }
        };
    });
    return targetElement;
}
//# sourceMappingURL=useTransitionEvent.mjs.mjs.map